import { rem } from 'polished'
import { fillArray } from 'lib/array/arrayUtils'
import styled from 'styled-components'
import LoadingBox from 'components/Common/Loading/LoadingBox'
import Group from 'components/utils/Group'
import TextLoadingBox from 'LuxKit/Typography/TextLoadingBox'
import {
  THINGS_TO_DO_DESCRIPTION_LINE_CLAMP,
  THINGS_TO_DO_TILE_CONTENT_GAP,
  THINGS_TO_DO_TILE_CONTENT_PADDING,
  thingsToDoPlaceTileImage,
  thingsToDoPlaceTileLayout,
} from './thingsToDoPlaceTileLayout'

const TileContainer = styled.div`
  ${thingsToDoPlaceTileLayout}
`

const ImageSection = styled.div`
  ${thingsToDoPlaceTileImage}
`

const ContentSection = styled(Group)`
  padding: ${rem(THINGS_TO_DO_TILE_CONTENT_PADDING)};
`

/* Derived from the clamp rather than a fixed list, which a raised clamp would silently truncate.
   The last line is short so the block reads as prose instead of a solid rectangle. */
const DESCRIPTION_LINE_WIDTHS = fillArray<`${number}%`>(
  THINGS_TO_DO_DESCRIPTION_LINE_CLAMP,
  (index) => (index === THINGS_TO_DO_DESCRIPTION_LINE_CLAMP - 1 ? '58%' : `${100 - index * 4}%`),
)

function ThingsToDoPlaceTileSkeleton() {
  return (
    <TileContainer data-testid="things-to-do-place-tile-skeleton">
      <ImageSection>
        <LoadingBox floating />
      </ImageSection>

      <ContentSection direction="vertical" gap={THINGS_TO_DO_TILE_CONTENT_GAP}>
        <Group direction="vertical" gap={4}>
          <TextLoadingBox typography="body-small" width="35%" />
          <TextLoadingBox typography="heading5" width="70%" />
        </Group>

        <Group direction="horizontal" gap={8} verticalAlign="center">
          <TextLoadingBox typography="body-small" width={72} />
          <TextLoadingBox typography="body-small" width={96} />
        </Group>

        <Group direction="vertical" gap={0}>
          {DESCRIPTION_LINE_WIDTHS.map((width) => (
            <TextLoadingBox key={width} typography="body-medium" width={width} />
          ))}
        </Group>
      </ContentSection>
    </TileContainer>
  )
}

export default ThingsToDoPlaceTileSkeleton
